export default "__VITE_ASSET__d8473880__"